import { Vue, Component } from 'vue-property-decorator';

import * as d3 from 'd3';
import _ from 'lodash';
import data from '@/data/d3basic-19983881105_e93c2d8279_b.jpg.json';

import {
  getHeight,
  getHeightDifference,
  getRgbColor,
  isBalanced,
  rotate
} from '@/utils/tree-utils';

@Component({})
export default class RadialTree extends Vue {
  private mounted() {
    const width: number = 932;
    const radius: number = width / 2;

    const tree = d3
      .tree()
      .size([2 * Math.PI, radius])
      // tslint:disable-next-line: triple-equals
      .separation((a, b) => (a.parent == b.parent ? 1 : 2) / a.depth);

    let root = tree(d3.hierarchy(data));

    const svg = d3
      .select('.radial-tree')
      .append('svg')
      .attr('width', width)
      .attr('height', width)
      // .style('background-color', 'black')
      .style('max-width', '100%')
      .style('height', 'auto')
      .style('font', '10px sans-serif')
      .style('margin', '5px');

    const gLink = svg
      .append('g')
      .attr('fill', 'none')
      .attr('stroke', '#555')
      .attr('stroke-opacity', 0.4)
      .attr('stroke-width', 1.5)
      .attr('transform', `translate(${width / 2},${width / 2})`);

    const gNode = svg
      .append('g')
      .attr('cursor', 'pointer')
      .attr('pointer-events', 'all')
      .attr('transform', `translate(${width / 2},${width / 2})`);

    function update() {
      console.log('update');

      const duration = d3.event && d3.event.altKey ? 2500 : 250;
      const nodes = root.descendants().reverse();
      const transition = svg.transition().duration(duration);

      root = tree(d3.hierarchy(data));

      gLink
        .selectAll('path')
        .data(root.links())
        .join('path')
        .attr(
          'd',
          // @ts-ignore
          d3
            .linkRadial()
            // @ts-ignore
            .angle(d => d.x)
            // @ts-ignore
            .radius(d => d.y)
        );

      // @ts-ignore
      const node = gNode.selectAll('g').data(nodes, d => d.data.name);

      const nodeEnter = node
        .enter()
        .append('g')
        .attr('stroke-linejoin', 'round')
        .attr('stroke-width', 2)
        .attr('transform', d => {
          console.log(d);
          return `
          rotate(${(d.x * 180) / Math.PI - 90})
          translate(${d.y},0)
        `;
        })
        .on('click', d => {
          onClickNode(d);
          update();
        });

      nodeEnter
        .append('circle')
        .attr('fill', getRgbColor)
        .attr('stroke', d => (isBalanced(d.data) ? 'none' : 'magenta'))
        .attr('r', d => 3);

      nodeEnter
        .append('text')
        .attr('dy', '0.31em')
        .attr('x', d => (d.x < Math.PI === !d.children ? 6 : -6))
        .attr('text-anchor', d =>
          d.x < Math.PI === !d.children ? 'start' : 'end'
        )
        .attr('transform', d => (d.x >= Math.PI ? 'rotate(180)' : null))
        // @ts-ignore
        .text(d => d.data.name)
        .clone(true)
        .lower();
      // .attr('stroke', getRgbColor);

      // Transition nodes to their new position.
      // @ts-ignore
      const nodeUpdate = node.merge(nodeEnter);

      // Transition exiting nodes to the parent's new position.
      const nodeExit = node.exit().remove();
    }

    update();

    function onClickNode(d) {
      const higherIdx = d.children.map(c => c.height).reduce(maxIdxReducer, 0);
      const rotationDir = +!higherIdx; // cast number to boolean, flip, and cast back to number
      rotate(d.data, rotationDir, d.parent.data);
      // console.log(data)
      function maxIdxReducer(acc, cur, idx, src) {
        if (cur > src[acc]) {
          acc = idx;
        }
        return acc;
      }
    }
  }
}
